<template>
  <div class="big-field">

    <div v-if="label" class="mb-2">
      <form-label>
        {{ label }}
      </form-label>
    </div>

    <slot name="field"></slot>

    <slot name="validationMessage"></slot>

  </div>

</template>

<script>

  export default {

    props: {
      label: {
        type: String,
        default: null,
      },
    },

  };

</script>
